export const config = {
    initialColorMode: 'light',
    useSystemColorMode: true,
};
